import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_INEPS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_INEP, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveINEP(obj).then(res => {
    commit(types.SET_INEP, res.data.data)
    return res
  })
}

export const deleteINEP = async ({ commit }, obj) => {
  await services.deleteINEP(obj).then(res => {
    return res
  })
}
